<main>
  <h2 class="mb-5">{{ text }}</h2>
  <mat-spinner></mat-spinner>
</main>
